import {create} from 'zustand'
import {useShallow} from 'zustand/react/shallow'

interface ModalState<T = any> {
    activePayload?: T;
    active?: string
    openModal: (key: string, payload?: T) => void
    closeModal: () => void
}

const useModalStore = create<ModalState>((set, get) => ({
    openModal: (key: string, payload?: any) => {
        set({activePayload: payload, active: key})
    },
    closeModal: () => {
        set({activePayload: undefined, active: undefined})
    }
}))

function useModal<T = any>(key: string) {
    return useModalStore(
        useShallow(state => {
            const isActive = state.active === key;
            return {
                isActive,
                payload: isActive ? (state.activePayload as T) : undefined
            };
        })
    )
}

export const openModal = useModalStore.getState().openModal;
export const closeModal = useModalStore.getState().closeModal;

export const getActivePayload = () => useModalStore.getState().activePayload;
export default useModal;